import { PageHeader, Select, Space, Tooltip } from "antd";
import { EyeOutlined, TagOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SelectInsumosItem, SelectItem, TableItem, dineroDisabledMask, round10Decimals } from "../../../../Components/Items";
import MandarCorreo from "../../Ventas/MandarCorreo/MandarCorreo";
import MandarCorreoOrdenDeCompra from "../../OrdenesDeCompras/MandarCorreoOrdenDeCompra/MandarCorreoOrdenDeCompra";
import ModalMandarCorreoFacturas from "../../FacturasCajaChica/ModalMandarCorreoFacturas/ModalMandarCorreoFacturas";
import ModalEtiquetasLote from "../../Lotes/ModalEtiquetasLote/ModalEtiquetasLote";
import DesgloseUbicacionesInsumo from "../Components/DesgloseUbicacionesInsumo";
import moment from "moment";
import "moment/locale/es";

moment.locale("es");

const { Option } = Select;

class Inventario extends Component {
  state = {
    loading: false,
    objetoProyectos: [],
    todasProyectos: [],
    objetoInsumos: [],
    todasInsumos: [],
    todasEntradasSalidas: [],
    proyectoId: this.props.location.state.proyectoId ? this.props.location.state.proyectoId : 0,
    insumoId: this.props.location.state.id,
    modalCorreoVenta: false,
    modalCorreoVentaId: null,
    modalCorreoOrdenCompra: false,
    modalCorreoOrdenCompraId: null,
    modalCorreoFacturaCompra: false,
    modalCorreoFacturaCompraId: null,
    modalEtiquetasLote: false,
    modalEtiquetasLoteId: null,
    modalEtiquetasLoteNumero: null,
    mostrarApartados: false,
  };

  abrirEtiquetasLote(record) {
    this.setState({
      modalEtiquetasLote: true,
      modalEtiquetasLoteId: record._id,
      modalEtiquetasLoteNumero: record.loteNumero || record.numero,
    });
  }

  cerrarEtiquetasLote() {
    this.setState({
      modalEtiquetasLote: false,
      modalEtiquetasLoteId: null,
      modalEtiquetasLoteNumero: null,
    });
  }

  abrirModalVerVenta(id) {
    this.setState({
      modalCorreoVenta: true,
      modalCorreoVentaId: id,
    });
  }

  cerrarMandarCorreoVenta() {
    this.setState({
      modalCorreoVenta: false,
      modalCorreoVentaId: null,
    });
  }

  abrirModalVerOrdenCompra(id) {
    this.setState({
      modalCorreoOrdenCompra: true,
      modalCorreoOrdenCompraId: id,
    });
  }

  cerrarModalVerOrdenCompra() {
    this.setState({
      modalCorreoOrdenCompra: false,
      modalCorreoOrdenCompraId: null,
    });
  }

  abrirModalVerFacturaCompra(id) {
    this.setState({
      modalCorreoFacturaCompra: true,
      modalCorreoFacturaCompraId: id,
    });
  }

  cerrarModalVerFacturaCompra() {
    this.setState({
      modalCorreoFacturaCompra: false,
      modalCorreoFacturaCompraId: null,
    });
  }

  async componentDidMount() {
    this.setState({ loading: true });
    await axios
      .post(
        this.props.location?.state?.consignacion ? "consignaciones/selectProyectosConsignaciones" : "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({
            todasProyectos: res.data.proyectos ? res.data.proyectos : res.data,
            objetoProyectos: (res.data.proyectos ? res.data.proyectos : res.data).map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    axios
      .post(
        "inventarios/selectEntradasSalidasProducto",
        { empresaId: this.props.empresaId, insumoId: this.state.insumoId, proyectoId: this.state.proyectoId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          this.setState({ todasEntradasSalidas: [] })
        } else {
          this.setState({
            todasEntradasSalidas: res.data
          });
        }
        this.setState({ loading: false });
      });
    this.setState({ loading: false });
  }

  onChangeProyectoInsumo(insumoId, proyectoId) {
    this.setState({ loading: true })
    axios
      .post(
        "inventarios/selectEntradasSalidasProducto",
        { empresaId: this.props.empresaId, insumoId, proyectoId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.status === 404) {
          this.setState({ todasEntradasSalidas: [] })
        } else {
          this.setState({
            todasEntradasSalidas: res.data
          });
        }
        this.setState({ loading: false, insumoId, proyectoId });
      });

  }

  handleMenuClick(e) {
    if (e.key === '1') {
      this.abrirAgregarInventario()
    }
    if (e.key === '2') {
      this.abrirTraspasoEntreAlmacenes()
    }
    if (e.key === '3') {
      this.abrirProductosAlCosto()
    }
  }

  render() {
    const columns = [
      // ✅ Nueva columna: Entradas (solo muestra cantidad si NO es salida)
      {
        title: "Fecha",
        dataIndex: "createdAt",
        responsive: ["md"],
        key: "createdAt",
        render: (value) => (
          <span style={{ fontWeight: 600 }}>
            {moment(value).locale("es").format("ll")}
          </span>
        ),
        width: "10%",
      },
      {
        title: "Concepto",
        dataIndex: "concepto",
        responsive: ["md"],
        key: "concepto",
        width: "20%",
        buscar: "concepto",
        render: (value) => (
          <span style={{ fontWeight: 600, color: "rgba(17, 24, 39, 1)" }}>
            {value}
          </span>
        ),
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        responsive: ["md"],
        key: "proyecto",
        render: (value) => (
          <span
            style={{
              display: "inline-block",
              padding: "2px 10px",
              borderRadius: 999,
              fontSize: 12,
              lineHeight: "18px",
              background: "rgba(59, 130, 246, 0.10)",
              border: "1px solid rgba(59, 130, 246, 0.25)",
              color: "rgba(30, 64, 175, 1)",
              maxWidth: 220,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
            title={value?.nombre}
          >
            {value?.nombre}
          </span>
        ),
        width: "10%",
      },

      {
        title: "Entradas",
        key: "entradas",
        width: "10%",
        align: "right",
        sorter: (a, b) => {
          const va = a.salida ? 0 : (a.cantidad || 0);
          const vb = b.salida ? 0 : (b.cantidad || 0);
          if (va < vb) return -1;
          if (va > vb) return 1;
          return 0;
        },
        render: (_, record) => {
          const isEntrada = !record.salida;
          const value = isEntrada ? (record.cantidad || 0) : null;

          return isEntrada ? (
            <span
              style={{
                display: "inline-block",
                padding: "2px 10px",
                borderRadius: 999,
                fontWeight: 600,
                fontSize: 12,
                lineHeight: "18px",
                background: "rgba(34, 197, 94, 0.12)",
                border: "1px solid rgba(34, 197, 94, 0.35)",
                color: "rgba(22, 101, 52, 1)",
                minWidth: 88,
                textAlign: "right",
              }}
            >
              {round10Decimals(value).toFixed(4)}
            </span>
          ) : (
            "-"
          );
        },
      },

      // ✅ Nueva columna: Salidas (solo muestra cantidad si ES salida)
      {
        title: "Salidas",
        key: "salidas",
        width: "10%",
        align: "right",
        sorter: (a, b) => {
          const va = a.salida ? (a.cantidad || 0) : 0;
          const vb = b.salida ? (b.cantidad || 0) : 0;
          if (va < vb) return -1;
          if (va > vb) return 1;
          return 0;
        },
        render: (_, record) => {
          const isSalida = !!record.salida;
          const value = isSalida ? (record.cantidad || 0) : null;

          return isSalida ? (
            <span
              style={{
                display: "inline-block",
                padding: "2px 10px",
                borderRadius: 999,
                fontWeight: 600,
                fontSize: 12,
                lineHeight: "18px",
                background: "rgba(239, 68, 68, 0.10)",
                border: "1px solid rgba(239, 68, 68, 0.35)",
                color: "rgba(153, 27, 27, 1)",
                minWidth: 88,
                textAlign: "right",
              }}
            >
              {round10Decimals(value).toFixed(4)}
            </span>
          ) : (
            "-"
          );
        },
      },

      // {
      //   title: "Cantidad Vendida",
      //   dataIndex: "cantidadVendida",
      //   key: "cantidadVendida",
      //   render: (value) => round10Decimals(value).toFixed(4),
      //   align: "right",
      //   width: "10%",
      // },

      {
        title: "Costo",
        dataIndex: "costo",
        responsive: ["md"],
        key: "costo",
        width: "10%",
        align: "right",
        render: (value) => (
          <span
            style={{
              display: "inline-block",
              padding: "2px 10px",
              borderRadius: 999,
              fontSize: 12,
              lineHeight: "18px",
              background: "rgba(107, 114, 128, 0.10)",
              border: "1px solid rgba(107, 114, 128, 0.25)",
              color: "rgba(31, 41, 55, 1)",
            }}
          >
            {dineroDisabledMask(value || 0)}
          </span>
        ),
      },

      // {
      //   title: "Costo Salida",
      //   dataIndex: "costoPromedioSalidas",
      //   responsive: ["md"],
      //   key: "costoPromedioSalidas",
      //   width: "10%",
      //   align: "right",
      //   render: (value) => value ? dineroDisabledMask(value || 0) : "-",
      // },

      //       {
      //   title: "Cantidad V",
      //   dataIndex: "cantidadVendida",
      //   key: "cantidadVendida",
      //   sorter: (a, b) => {
      //     if (a.cantidadVendida < b.cantidadVendida) {
      //       return -1;
      //     }
      //     if (a.cantidadVendida > b.cantidadVendida) {
      //       return 1;
      //     }
      //     return 0;
      //   },
      //   render: (value) => round10Decimals(value).toFixed(4),
      //   width: "20%",
      // },

      {
        title: "Saldo",
        dataIndex: "saldo",
        key: "saldo",
        sorter: (a, b) => {
          if (a.saldo < b.saldo) {
            return -1;
          }
          if (a.saldo > b.saldo) {
            return 1;
          }
          return 0;
        },
        width: "10%",
        align: "right",
        render: (value) => (
          <span style={{ fontWeight: 700 }}>
            {round10Decimals(value || 0).toFixed(4)}
          </span>
        ),
      },
      {
        title: "Usuario",
        dataIndex: "usuario",
        responsive: ["md"],
        key: "usuario",
        render: (value) => (
          <span style={{ fontWeight: 600 }}>
            {value?.nombre}
          </span>
        ),
        width: "10%",
      },
      {
        title: "Acciones",
        dataIndex: "acciones",
        key: "acciones",
        width: "10%",
        render: (value, record) => {
          let botones = []

          if (record.ventaId){
            botones.push(
              <Tooltip key="verVenta" title="Ver Venta" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="text"
                  onClick={() => this.abrirModalVerVenta(record.ventaId)}
                  icon={<EyeOutlined />}
                />
              </Tooltip>
            )
          }

          // Los dos if son independientes a proposito: hoy aumentarInventario llena
          // uno u otro, pero si llegaran los dos se ven ambos botones.
          if (record.ordendecompraId){
            botones.push(
              <Tooltip key="verOrdenCompra" title="Ver Orden de Compra" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="text"
                  onClick={() => this.abrirModalVerOrdenCompra(record.ordendecompraId)}
                  icon={<EyeOutlined />}
                />
              </Tooltip>
            )
          }

          if (record.facturaId){
            botones.push(
              <Tooltip key="verFacturaCompra" title="Ver Factura de Compra" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="text"
                  onClick={() => this.abrirModalVerFacturaCompra(record.facturaId)}
                  icon={<EyeOutlined />}
                />
              </Tooltip>
            )
          }

          if (!record.salida) {
            botones.push(
              <Tooltip key="etiquetaLote" title="Imprimir etiqueta" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
                <ButtonItem
                  type="default"
                  size="small"
                  morado
                  onClick={() => this.abrirEtiquetasLote(record)}
                  icon={<TagOutlined />}
                />
              </Tooltip>
            )
          }

          return botones
        },
      },
    ];
    return (
      <>
        <PageHeader
          title={'Inventario - Insumo'}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Space style={{ width: "100%", minWidth: 700 }}>
              <SelectInsumosItem
                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                headersToken={this.props.headersToken}
                onChange={(value) => this.onChangeProyectoInsumo(value, this.state.proyectoId)}
                value={this.state.insumoId}
                autoFocus
                dropdownMatchSelectWidth={600}
                width={550}
                placeholder="Insumo"
                tiposInsumos="inventariables"
              />
              <SelectItem
                placeholder="Proyecto"
                width={150}
                onChange={(value) => this.onChangeProyectoInsumo(this.state.insumoId, value)}
                value={this.state.proyectoId}
              >
                <Option value={0}>Todos</Option>
                {this.state.objetoProyectos}
              </SelectItem>
              {this.state.todasEntradasSalidas.filter((value) => value.esMovimientoApartado).length > 0 && (
                <ButtonItem
                  type={this.state.mostrarApartados ? "primary" : "default"}
                  onClick={() => this.setState({ mostrarApartados: !this.state.mostrarApartados })}
                >
                  {this.state.mostrarApartados
                    ? "Ocultar apartados"
                    : `Mostrar apartados (${this.state.todasEntradasSalidas.filter((value) => value.esMovimientoApartado).length})`}
                </ButtonItem>
              )}
            </Space>
          }
        />
        {this.props.moduloWms && !!this.state.proyectoId && (
          <DesgloseUbicacionesInsumo
            empresaId={this.props.empresaId}
            headersToken={this.props.headersToken}
            proyectoId={this.state.proyectoId}
            insumoId={this.state.insumoId}
          />
        )}
        <TableItem
          size="small"
          dataSource={this.state.mostrarApartados ? this.state.todasEntradasSalidas : this.state.todasEntradasSalidas.filter((value) => !value.esMovimientoApartado)}
          columns={columns}
          pagination={false}
          loading={this.state.loading}
        />
        <MandarCorreo
          visible={this.state.modalCorreoVenta}
          id={this.state.modalCorreoVentaId}
          cerrarMandarCorreo={this.cerrarMandarCorreoVenta.bind(this)}
        />
        <MandarCorreoOrdenDeCompra
          visible={this.state.modalCorreoOrdenCompra}
          id={this.state.modalCorreoOrdenCompraId}
          cerrarMandarCorreoOrdenDeCompra={this.cerrarModalVerOrdenCompra.bind(this)}
        />
        <ModalMandarCorreoFacturas
          visible={this.state.modalCorreoFacturaCompra}
          id={this.state.modalCorreoFacturaCompraId}
          cerrarModalMandarCorreoFacturas={this.cerrarModalVerFacturaCompra.bind(this)}
        />
        <ModalEtiquetasLote
          visible={this.state.modalEtiquetasLote}
          loteId={this.state.modalEtiquetasLoteId}
          loteNumero={this.state.modalEtiquetasLoteNumero}
          onCancel={this.cerrarEtiquetasLote.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    moduloWms: state.empresa.moduloWms,
  };
};

export default connect(mapStateToProps)(Inventario);
